module.exports = __webpack_public_path__ + "img/awlr.e078431b.svg";